export const defaultHeartSvg = `
<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" width="34" height="31" viewBox="0 0 34 31">
  <path d="M24.3 1.4c-2.6 0-5.3 1.1-7.3 3.1C15 2.8 12.6 1 10.2 1 8 1 5.5 2 3.7 3.8a10 10 0 000 13.7l12.5 12.2c.3.2.5.3.8.3.3 0 .6-.1.8-.3l12.5-12.2a9.8 9.8 0 002.7-6.8c0-2.5-1-5-2.7-6.8a8.6 8.6 0 00-6-2.5z"/>
</svg>
`;
